import React from "react";
import { Container, SectionLabel } from "../components/ui-kit";
import PageHero from "../components/PageHero";
import { ShieldCheck } from "lucide-react";

const SECTIONS = [
  ["Governance", "We operate with professional governance structures, clear roles and accountability."],
  ["Responsible Giving", "We present initiatives honestly and never use manipulative or sensational language."],
  ["Partner Due Diligence", "Every partner is subject to verification and documented due diligence before activation."],
  ["Financial Controls", "Transactions are recorded in an internal ledger; completed financial records are never deleted."],
  ["Impact Reporting", "We publish only verified impact metrics and outcomes."],
  ["Data Protection", "We protect personal data and apply privacy-conscious architecture."],
  ["Complaints", "We provide a clear complaints and grievance process."],
  ["Safeguarding", "We uphold safeguarding, including child safeguarding, across initiatives."],
  ["Anti-Fraud", "We apply fraud controls including transaction monitoring and manual review."],
  ["AML / CFT", "We maintain anti-money-laundering and counter-financing-of-terrorism awareness."],
  ["Ethical Conduct", "We hold ourselves to a high standard of ethical conduct in all activities."],
];

export default function Transparency() {
  return (
    <div>
      <PageHero
        label="Transparency Centre"
        title="Our commitment to transparency"
        subtitle="Confidence for banks, payment providers, corporate partners, supporters and international organisations."
        crumbs={[{ label: "Transparency" }]}
      />
      <section className="bg-white">
        <Container className="py-16">
          <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
            {SECTIONS.map(([title, text]) => (
              <div key={title} className="rounded-2xl border border-emerald-900/10 bg-sand p-6">
                <div className="flex items-center gap-2 text-emerald-800"><ShieldCheck className="h-5 w-5" /><h3 className="font-display text-lg font-bold text-emerald-900">{title}</h3></div>
                <p className="mt-2 text-sm leading-relaxed text-slate-600">{text}</p>
              </div>
            ))}
          </div>
          <div className="mt-12 rounded-2xl border border-gold/30 bg-gold-soft p-6 text-sm leading-relaxed text-emerald-900">
            We only make claims that are specifically configured and verified by an administrator. We do not claim to be a registered charity, government approved, or authorised to collect worldwide unless such statements are explicitly configured and substantiated.
          </div>
        </Container>
      </section>
    </div>
  );
}
